/* eslint-disable no-loop-func */
'use strict';

var base = require('base/checkout/formErrors');

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $('error-message-text').text('');
    $('.error-message-title').text('');
    $('.error-message').hide();
}

function removeEmoji(inputTarget) {
    var regex = new RegExp(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g);
    inputTarget.value = inputTarget.value.replace(regex, '');
}
function eventListenerValidationsForm() {
    var inputs = $('input.form-control:text');
    for (var i = 0; i < inputs.length; i++) {
        var input = inputs[i];
        input.addEventListener('change', (e) => {
            removeEmoji(e.target);
        });
    }
}

base.eventListenerValidationsForm = eventListenerValidationsForm;
base.clearPreviousErrors = clearPreviousErrors;
module.exports = base;
